import { memo } from "react";
import "./LeftDrawer.scss";
import { Divider, Space, Tooltip, Button, Typography } from "antd";

const LeftDrawer = ({ rawImagesList: data, handleActiveItem, activeItem, openRightDialog = null, closeRightDialog = null }) => {
  const getBorder = (elm, index) => {
    if (activeItem?.posType === "rawImages" && index === activeItem?.index) {
      return "1px solid red";
    }
    if (
      (activeItem?.posType === "brandLinks" || activeItem?.posType === "articleImages") &&
      index === activeItem?.index
    ) {
      return "1px solid red";
    }
    if (elm?.imageToShow?.imageType?.toLowerCase() === "cc") {
      return "2.5px solid #88D78F";
    }
    return "none";
  };

  const firstArticleImageIndex = data?.findIndex((el) => el.posType === "articleImages") ?? -1;
  const firstBrandLinkIndex = data?.findIndex((el) => el.posType === "brandLinks") ?? -1;
  const thumbs = () => {
    return data.map((elm, index) => (
      <div key={index}>
        <hr
          style={{
            display: index === 0 ? "none" : "block",
            margin: "3px 0",
            padding: 0,
          }}
        />
        {index === firstArticleImageIndex && (
          <Typography.Text type="secondary" style={{ fontSize: "0.7rem", display: "block", marginBottom: 2 }}>
            Article images
          </Typography.Text>
        )}
        {index === firstBrandLinkIndex && (
          <Typography.Text type="secondary" style={{ fontSize: "0.7rem", display: "block", marginBottom: 2 }}>
            Brand links
          </Typography.Text>
        )}
        {/* <Tooltip trigger={"hover"} title={elm?.imageToShow?.name ?? ""}> */}
        <div
          className="left_thumb_item "
          onClick={() => {
            handleActiveItem(elm, index, elm.posType ?? "rawImages");
            closeRightDialog();
          }}
          style={{
            border: getBorder(elm, index),
            cursor: "pointer",
          }}
        >
          {elm?.pii && <span className="thumb_tag">PII</span>}
          {elm?.imageToShow?.imageType ? (
            <Tooltip title={elm?.imageToShow?.imageType}>
              <img
                src={elm?.imageToShow?.thumbPath?.url}
                alt={"img" + index}
                className="left_carousel_img"
              />
            </Tooltip>
          ) : (
            <img
              src={elm?.imageToShow?.thumbPath?.url}
              alt={"img" + index}
              className="left_carousel_img"
            />
          )}
        </div>
        {/* </Tooltip> */}
      </div>
    ));
  };
  return (
    <div className="raw-images-wrapper">
      <Space direction="vertical" size={0} className="top-space">
        <Tooltip title="CSV Information">
          <Button className="left_thumb_item" type="text" style={{
            block: true,
            width: "100%",
            border: "1px solid #777",
            backgroundImage: "url(/images/csv_info_thumb.jpg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }} onClick={() => openRightDialog()} />
        </Tooltip>
        {thumbs()}
      </Space>
    </div>
  );
};

export default memo(LeftDrawer);
